import React from 'react';

const Soporte = () => {
  return (
    <section id="soporte" className="text-gray-800 bg-gray-50 py-24 border-t border-gray-200">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-extrabold text-center mb-6 text-blue-900">Soporte que te Acompaña Siempre</h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
          Nuestro compromiso va más allá del servicio: resolvemos, acompañamos y mejoramos tu experiencia digital en cada etapa.
        </p>

        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {supportItems.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition duration-300 text-center"
            >
              <div className="text-4xl mb-4 text-blue-600">{item.icon}</div>
              <h3 className="text-xl font-semibold text-blue-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-base leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-xl mx-auto bg-white p-8 rounded-2xl shadow-md">
          <h3 className="text-2xl font-semibold mb-4 text-blue-900 text-center">¿Necesitás ayuda?</h3>
          <form className="space-y-4">
            <input
              type="text"
              placeholder="Nombre"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option>Selecciona un motivo</option>
              <option>Consulta general</option>
              <option>Soporte técnico</option>
              <option>Revisión de resultados</option>
              <option>Otro</option>
            </select>
            <textarea
              placeholder="Escribe tu mensaje..."
              rows="4"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            ></textarea>
            <button
              type="submit"
              className="w-full bg-blue-700 hover:bg-blue-900 text-white font-bold py-3 rounded-lg transition duration-300"
            >
              Enviar Mensaje
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

const supportItems = [
  {
    icon: '💬',
    title: 'Asistencia Personalizada',
    description: 'Chats en vivo, WhatsApp y correo directo con respuesta en menos de 24 h.',
  },
  {
    icon: '📚',
    title: 'Centro de Ayuda',
    description: 'Tutoriales, preguntas frecuentes y guías paso a paso para todo lo que necesites.',
  },
  {
    icon: '🛠',
    title: 'Soporte Técnico',
    description: 'Reporta bugs o incidencias y sigue el estado de la solución con actualizaciones periódicas.',
  },
  {
    icon: '📈',
    title: 'Revisión de Resultados',
    description: 'Evaluamos contigo el impacto de nuestras acciones en reuniones mensuales.',
  },
  {
    icon: '🤝',
    title: 'Acompañamiento Estratégico',
    description: 'Te asesoramos sobre nuevas oportunidades y mejoras continuas en tu presencia digital.',
  },
  {
    icon: '🔒',
    title: 'Seguridad y Confianza',
    description: 'Protegemos tu información y cumplimos con estándares de privacidad y seguridad.',
  },
];

export default Soporte;
